import React, { memo } from "react";
import styled from "styled-components";
import GroupsList from "./groups_list";
import GroupSettings from "./group_settings";

const GroupsTabContainer = styled.div`
  position: relative;
`;

const AdminPageGroupsTab = () => {
  return (
    <GroupsTabContainer>
      <GroupsList />
      <GroupSettings />
    </GroupsTabContainer>
  );
};

export default memo(AdminPageGroupsTab);
